<template>
  <div>
    <div class="ele-box">
      <div class="fixedTop">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="领取" name="领取">
          </el-tab-pane>
          <el-tab-pane label="入库" name="入库">
          </el-tab-pane>
          <el-tab-pane label="下发" name="下发">
          </el-tab-pane>
          <el-tab-pane label="出库" name="出库">
          </el-tab-pane>
        </el-tabs>
        <div class="topCont">
         <!-- <div class="items">
            <el-input v-model="from.recordNo" :placeholder="handleIndex==0?'输入领取记录编号':handleIndex==1?'输入入库记录编号':handleIndex==2?'输入下发记录编号':'输入出库记录编号'"></el-input>
          </div> -->
          <div class="items">
            <el-date-picker
              v-model="from.createDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :placeholder="handleIndex==0?'选择领取时间':handleIndex==1?'选择入库时间':handleIndex==2?'选择下发时间':'选择出库时间'">
            </el-date-picker>
          </div>
          <div class="items" style="width: 150px;">
            <el-select v-model="from.typeCode" placeholder="请选择分类">
              <el-option
                v-for="item in type"
                :key="item.typeCode"
                :label="item.typeName"
                :value="item.typeCode">
              </el-option>
            </el-select>
          </div>
          <div class="items">
            <el-input v-model="from.name" placeholder="输入物料名称"></el-input>
          </div>
          <!-- <div class="items" style="width: 150px;">
            <el-select v-model="from.code" placeholder="请选择下发人">
              <el-option
                v-for="item in xiafaList"
                :key="item.code"
                :label="item.realName"
                :value="item.code">
              </el-option>
            </el-select>
          </div> -->
          <div class="items">
            <el-button type="success" plain @click="onSubmit">搜索</el-button>
            <el-button type="info" plain @click="reset">重置</el-button>
          </div>
          <div class="totles over_h">共 {{total}} 条记录</div>
        </div>
        <div class="botCont">
          <el-table
            :data="list"
            height="450"
            border
            fixed
            style="width:1800px;text-align: center;">
            <el-table-column
             type="index"
              label="序号"
              width="60">
            </el-table-column>

            <el-table-column
              prop="recordNo"
              :label="handleIndex==0?'领取记录编号':handleIndex==1?'入库记录编号':handleIndex==2?'下发记录编号':'出库记录编号'"
              width="220">
            </el-table-column>
            <el-table-column
              prop="createTime"
              :label="handleIndex==0?'领取时间':handleIndex==1?'入库时间':handleIndex==2?'下发时间':'出库时间'"
              width="220">
            </el-table-column>
            <el-table-column
              prop="name"
              width="190"
              label="物料名称">
            </el-table-column>
            <el-table-column
              prop="typeName"
              label="分类">
            </el-table-column>
            <el-table-column
              prop="specification"
              width="180"
              label="产品规格">
            </el-table-column>
            <el-table-column
              prop="mintagunit"
              width="180"
              label="入库单位">
            </el-table-column>
            <el-table-column
              prop="prsNum"
              width="80"
              label="数量">
            </el-table-column>
            <el-table-column
               :label="handleIndex==0?'下发人':handleIndex==1?'操作员':handleIndex==2?'领取人':'出库对象'">
               <template slot-scope="scope">
                 <div class="actionBox" v-if="handleIndex==0">
                    {{scope.row.distributeBy}}
                 </div>
                 <div class="actionBox" v-if="handleIndex==1">
                    {{scope.row.realName}}
                 </div>
                 <div class="actionBox" v-if="handleIndex==2">
                    {{scope.row.receiveBy}}
                 </div>
                 <div class="actionBox" v-if="handleIndex==3">
                    {{scope.row.userTargetAudience}}
                 </div>
               </template>
            </el-table-column>
            <el-table-column
            v-if="handleIndex==3"
              prop="contactNumber"
              width="160"
              label="联系方式">
            </el-table-column>
            <el-table-column
              prop="remarks"
              width="160"
              label="备注">
            </el-table-column>
            <!-- <el-table-column
              prop="action"
              label="操作"
              width="150">
              <template slot-scope="scope">
                <div class="actionBox">
                  <div class="cursor showDetail">下载二维码</div>
                  <div class="cursor showDetail" @click="deletes(scope.row.id)">删除</div>
                </div>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentPage"
            @prev-click="prev"
            @next-click="next"
             :page-size="10"
            :total="total" style="margin-top:50px">
          </el-pagination>
        </div>
      </div>
  </div>
  </div>
</template>
<script>
import {
  pageMatterRecord,
  delMatterRecord,
  countMatterInfoByC,
  getUserListByAreasId,
  getUserList
} from '@/api/material'
export default {

  data() {
    return {
      value1: '',
      activeName: '领取',
      breedRecordNo:'',
      type:[],
      xiafaList:[],
      showForm: {
        id: '',
      },
      showForm2: {
        id: '',
      },
      form: {
        realName: '',
        phone: '',
       queryCityAreas:'',
         pageNo: 1,
         pageSize: 200,
        optAuthType:null
      },
      showFormVisible: false,
      showFormVisible2:false,
      handleIndex:0,
      list:[],
      from:{
        recordNo:'',
        curDay:'',
        typeCode:'',
        name:'',
        code:'',
      },
      infoQuery:{
        recordNo:'',
        curDay:'',
        typeCode:'',
        type:10,
        pageNo:1,
        pageSize:5,
        name:'',
        code:'',
      },
      total:0,
    }
  },
  mounted() {
    this.getList()
    this.types()
    // this.getUserListByAreasIdS()
  },
  methods:{

    onSubmit(e){
      this.infoQuery.recordNo = this.from.recordNo
      this.infoQuery.curDay = this.from.createDate
      this.infoQuery.typeCode = this.from.typeCode
      this.infoQuery.name = this.from.name
      this.infoQuery.code = this.from.code
      this.getList()
    },
    reset(){
      this.infoQuery.recordNo = ''
      this.infoQuery.curDay = ''
      this.infoQuery.typeCode = ''
      this.infoQuery.name = ''
      this.infoQuery.code = ''
      this.from.recordNo = ''
      this.from.createDate = ''
      this.from.typeCode = ''
      this.from.name = ''
      this.from.code = ''
      this.getList()
    },
    //分类
    //countMatterInfoByC
    types(){
      var _this = this
      countMatterInfoByC()
      .then( res => {
        if (res.data.code == 0) {
          _this.type = res.data.data
        } else {
          _this.$message({
            type: 'info',
            message: res.data.msg
          })
        }
      })
    },

    //下发人
    // getUserListByAreasIdS(){
    //   var _this = this
    //   getUserList(this.form)
    //   .then( res => {
    //     if (res.data.code == 0) {
    //      _this.xiafaList = res.data.data
    //     } else {
    //       _this.$message({
    //         type: 'info',
    //         message: res.data.msg
    //       })
    //     }
    //   })
    // },

    //删除
    deletes(id){
      var _this = this
      this.$confirm('是否确定删除该数据？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
      .then(() => {
        delMatterRecord(id)
        .then(res => {
         _this.$message({
             type: 'info',
             message: '已删除'
           });
        });
      })
      .catch(action => {
        _this.$message({
          type: 'info',
          message: action === 'cancel'
            ? '放弃保存并离开页面'
            : '停留在当前页面'
        })
      });


    },

    async getList(){
      // pageMatterRecord
      var _this = this
      await pageMatterRecord(_this.infoQuery)
        .then(res => {
          // if()
          _this.total = res.data.data.total
          _this.loading = false
          if (res.data.code == 0) {
            _this.list = res.data.data.records
            console.log(_this.list)

          } else {
            _this.$message({
              type: 'info',
              message: res.data.msg
            })
          }
        })
        .catch(err => {
          _this.loading = false
          // _this.$message.error('加载失败，请稍后再试！')
        })

    },
    currentPage(e){
      console.log(e)
      this.loading = true
      this.infoQuery.pageNo = e
      this.getList()
    },
    prev(e){
      this.loading = true
       this.infoQuery.pageNo = e
      this.getList()
    },
    next(e){
      console.log(e)
      this.loading = true
       this.infoQuery.pageNo = e
      this.getList()
    },
    handleClick(tab, event) {
      this.handleIndex = tab.index
     // console.log(tab, event);
      if(this.handleIndex==0){
        this.infoQuery.type=10
      }
      if(this.handleIndex==1){
        this.infoQuery.type=1
      }
      if(this.handleIndex==2){
        this.infoQuery.type=20
      }
      if(this.handleIndex==3){
        this.infoQuery.type=2
      }
      this.getList()

    },
    //配种记录查看详情
    pzshowDetail:function(index){
      this.showFormVisible2 = true
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.showFormVisible = false
      this.showFormVisible2 = false
    },
    scshowDetail:function(){
      this.showFormVisible = true
    },

  },
  // 注册组件
  components: {

  },
  created() {

  },
}
</script>

<style scoped>
  /deep/ .el-tabs__item{
    width: 90px;
    height: 60px;
    text-align: center;
    font-size: 17px;
    padding: 5px 0;
    cursor: pointer;
  }
  /deep/ .el-tabs__item.is-active{
    color: #30BF30;
    font-weight: bold;
  }
  /deep/ .el-tabs__active-bar{
    width: 90px;
  }
  /deep/ .el-tabs__nav-wrap::after{
    height:1px
  }
  .el-button--primary{
    float: right;
  }
  .el-button--primary:focus,
  .el-button--primary:hover{
    background-color: #30BF30;
    border-color: #30BF30;
  }
  /deep/ .el-button--success.is-plain{
    border-color: rgba(48, 191, 48, 1);
    color: #30BF30 !important;
    background: #fff;
  }
  /deep/ .el-button--info.is-plain{
    background: rgba(245, 245, 245, 1);
    color:#333;border-color:rgba(245, 245, 245, 1)
  }
  .actionBox div{
    display: inline-block;margin: 0 5px;
  }
  /deep/ .has-gutter tr th{
    background: #f5f7fa;
  }
  /deep/ .el-table th.el-table__cell>.cell{
    color:#333;font-size: 14px
  }
  /deep/ .el-table .el-table__cell{
    font-size: 14px
  }
</style>



// WEBPACK FOOTER //
// src/views/material/list.vue